module.exports = __webpack_public_path__ + "img/backimg.b81b0119.png";